// DB-Frontend/src/pages/ThankYou.js
import React from "react";
import { Link } from "react-router-dom";
import logo from "../../Assets/images/logo.png";
import Header from "../Header/header";
import Footer from "../Footer/footer";

function ThankYou() {
  return (
    <>
      <Header />
      <div className="flex flex-col text-black items-center justify-center py-28 lg:py-40 text-center p-4">
        <img src={logo} alt="AMN Logo" className="w-20 h-20 mx-auto mb-4" />
        <h1 className="text-4xl font-bold">AMN</h1>
        <p className="mt-6 text-xl">
          Thank you for submitting your information!
        </p>
        <Link
          to="/"
          className="mt-4 underline text-primary hover:text-blue-400"
        >
          Go to the website.
        </Link>
      </div>
      <Footer />
    </>
  );
}

export default ThankYou;
